import { styled } from '../../Utilities';
import { ColorPickerBase } from './ColorPicker.base';
import { getStyles } from './ColorPicker.styles';
export var ColorPicker = styled(ColorPickerBase, getStyles, undefined, { scope: 'ColorPicker' });
//# sourceMappingURL=ColorPicker.js.map